import { memo } from 'react'
import { styled } from '@mui/material/styles'
import Skeleton from '@mui/material/Skeleton'

import { Logo, bankLogos } from 'components/LoadingLead/Logos'

const FAKE_BANKS = [
  'targobank',
  'ingDiba',
  'commerzbank',
  'dkb',
  'postbank',
  'deutscheBank'
]

const SKELETONS_NUMBER = 4
const DEFAULT_HEIGHT = 32

const getBankNames = (fakeBankListNames?: string[]): string[] => {
  if (fakeBankListNames) {
    return fakeBankListNames
  }
  return FAKE_BANKS
}

interface FakeOffersProps {
  fakeBankListNames?: string[]
}

const FakeOffers = ({ fakeBankListNames }: FakeOffersProps) => {
  const fakeBanks = getBankNames(fakeBankListNames)
  const arrayTemplate = [...Array(SKELETONS_NUMBER)]

  return (
    <Root>
      {fakeBanks.map((fakeBank) => {
        const logoId = String(bankLogos[fakeBank as keyof typeof bankLogos])

        return (
          <FakeOffer key={logoId}>
            <FakeOfferTitle>
              <Logo logoId={logoId} bankName={fakeBank} />
            </FakeOfferTitle>

            <SkeletonsContainer>
              {arrayTemplate.map((element, index) => (
                <SkeletonBlock key={`skeletonblock-${element || index}`}>
                  <RoundedSkeleton
                    width="90%"
                    height={DEFAULT_HEIGHT}
                    animation="wave"
                  />
                  <RoundedSkeleton width="100%" height={16} animation="wave" />
                </SkeletonBlock>
              ))}
            </SkeletonsContainer>
          </FakeOffer>
        )
      })}
    </Root>
  )
}

export default memo(FakeOffers)

const Root = styled('div')(({ theme }) => ({
  position: 'relative',
  width: '100%',
  marginTop: theme.spacing(4)
}))

const FakeOffer = styled('div')(({ theme }) => ({
  position: 'relative',
  marginBottom: theme.spacing(2),
  borderRadius: '8px',
  zIndex: 1,
  border: `1px solid ${theme.palette.grey[300]}`
}))

const FakeOfferTitle = styled('div')({
  '& img': {
    height: '30px'
  },
  position: 'relative',
  background: 'none',
  display: 'flex',
  alignItems: 'center',
  height: '44px',
  padding: '16px'
})

const RoundedSkeleton = styled(Skeleton)({
  borderRadius: '20px/40px'
})

const SkeletonsContainer = styled('div')(({ theme }) => ({
  display: 'grid',
  width: '100%',
  borderTop: `1px solid ${theme.palette.grey[300]}`,
  borderRadius: '0 0 8px 8px',
  [theme.breakpoints.up('xs')]: {
    gridTemplateColumns: 'repeat(2, 50%)'
  },
  [theme.breakpoints.up('sm')]: {
    gridTemplateColumns: 'repeat(4, 25%)'
  }
}))

const SkeletonBlock = styled('div')(({ theme }) => ({
  padding: theme.spacing(2.5),
  zIndex: -1,
  '&:nth-child(n+3)': {
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'block'
    }
  }
}))
